import { Component, OnInit ,HostListener, Inject} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../_services';
import { Router, RouterOutlet } from '@angular/router';
import { fader } from '../route-animation';

import { User } from '../../_models';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styles: [],
  animations: [ fader ]
})
export class LayoutComponent implements OnInit {



  currentUser: User;
  isMenuCollapsed = true;

  elem: any;
  isFullScreen: boolean;

  currentYear = 2021;

  constructor(public router: Router, private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: any) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

  }

  @HostListener('document:fullscreenchange', ['$event'])
   @HostListener('document:webkitfullscreenchange', ['$event'])
   @HostListener('document:mozfullscreenchange', ['$event'])
   @HostListener('document:MSFullscreenChange', ['$event'])
   fullscreenmodes(event){
    this.chkScreenMode();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.chkScreenMode();
    this.elem = document.documentElement;
  }


  chkScreenMode(){
    if(document.fullscreenElement){
      //fullscreen
      this.isFullScreen = true;
    }else{
      //not in full screen
      this.isFullScreen = false;
    }
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }



  logout() {
      this.authenticationService.logout();
      this.router.navigate(['/login']);
  }

}
